import React, { useState } from "react";

import Select from "react-select";
import "./AccessDetails.scss";
import {
  checkHasLowerLetter,
  checkHasNumber,
  checkHasSpecial,
  checkHasUpperLetter,
} from "../../../../utils/commonFunctions";
import PasswordValidationCard from "../../../commons/PasswordValidationCard/PasswordValidationCard";
import { hideEyeGray, viewEyeGray } from "../../../../assets/images";
import { ToggleSwitch } from "../../../commons";
import {
  AccessDetails as AccessDetailsType,
  BasicType,
  LoginResponseType,
  UserProfileType,
} from "../../../../redux/auth/authTypes";
import { useLocation } from "react-router-dom";

type PasswordResultType = {
  least: boolean;
  uppercase: boolean;
  special: boolean;
  lower: boolean;
  number: boolean;
};

type AppProps = {
  data?: BasicType;
  isEdit?: boolean | string;
  handleAccessDeatilsForm?: (data: any) => void;
  setProfileForm?: any;
  handleToggleIsAccess: any;
  access: boolean;
  profileDetailsError?: any;
  setNewPassword?: (data: string) => void;
  newPassword?: string;
  finalUserGroupList: any;
  setAssignGroup: (data: string) => void;
  setOffset: (data: any) => void;
  setPasswordResult?: (data: any) => void;
  passwordResult?: PasswordResultType;
  fetchingUser: boolean;
  isNotShow?: boolean;
  isDisabledEditField?: boolean;
  loginData?: LoginResponseType;
};
const AccessDetails = ({
  data,
  isEdit,
  handleAccessDeatilsForm,
  setProfileForm,
  handleToggleIsAccess,
  profileDetailsError,
  setNewPassword,
  access,
  newPassword,
  finalUserGroupList,
  setAssignGroup,
  setOffset,
  passwordResult,
  setPasswordResult,
  fetchingUser,
  isNotShow,
  loginData,
  isDisabledEditField,
}: AppProps) => {
  const [passwordPopUpShow, serPasswordPopUpshow] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const addPresent = useLocation()?.pathname?.includes("add");
  const handlePassword = (e: any) => {
    serPasswordPopUpshow(true);
    setNewPassword && setNewPassword(e.target.value.trim());
    handleAccessDeatilsForm && handleAccessDeatilsForm(e);
    if (e.target.value && setPasswordResult) {
      let specialCharacterValue = checkHasSpecial(e.target.value);
      let uppercaseLetterValue = checkHasUpperLetter(e.target.value);
      let lowercaseLetterValue = checkHasLowerLetter(e.target.value);
      let numbercaseLetterValue = checkHasNumber(e.target.value);

      if (e.target.value.length >= 8) {
        setPasswordResult((prv: any) => ({
          ...prv,
          least: true,
        }));
      }

      if (lowercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          lower: true,
        }));
      }

      if (specialCharacterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          special: true,
        }));
      }
      if (uppercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          uppercase: true,
        }));
      }

      if (!uppercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          uppercase: false,
        }));
      }
      if (numbercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          number: true,
        }));
      }
      if (!numbercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          number: false,
        }));
      }

      if (!specialCharacterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          special: false,
        }));
      }
      if (!lowercaseLetterValue) {
        setPasswordResult((prv: any) => ({
          ...prv,
          lower: false,
        }));
      }
      if (e.target.value.length < 8) {
        setPasswordResult((prv: any) => ({
          ...prv,
          least: false,
        }));
      }
    } else {
      setPasswordResult &&
        setPasswordResult({
          least: false,
          uppercase: false,
          special: false,
          number: false,
        });
    }
  };

  const checkBottom = (e: any) => {
    // setLoadCondition(false);
    setOffset((prv: any) => prv + 20);
  };

  const popOver = (e: any) => {
    serPasswordPopUpshow(false);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  return (
    <div className="form-group">
      <h6>ACCESS DETAILS</h6>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="jobTitle">Assign Group</label>
          <Select<any, false>
            id="some_id"
            inputProps={{
              autoComplete: "off",
              autoCorrect: "off",
              spellCheck: "off",
            }}
            // inputProps={{ autoComplete: "nope" }}
            // onBlur={() => onBlur(value)}

            placeholder={"Select Group"}
            options={finalUserGroupList}
            value={
              data &&
              data?.access_details &&
              data?.access_details?.assigned_group &&
              data?.access_details?.assigned_group?.group_name && {
                label: data?.access_details?.assigned_group?.group_name,
                value: data?.access_details?.assigned_group?.group_id,
              }
            }
            onChange={(e: any) => {
              if (e) {
                setProfileForm((prv: UserProfileType) => {
                  return {
                    ...prv,
                    user_details: {
                      ...prv?.user_details,
                      basic_details: {
                        ...prv?.user_details.basic_details,
                        access_details: {
                          ...prv?.user_details?.basic_details?.access_details,
                          assigned_group: {
                            ...prv?.user_details?.basic_details?.access_details
                              .assigned_group,
                            group_id: e?.value,

                            group_name: e?.label,
                          },
                        },
                      },
                    },
                  };
                });
              }
            }}
            onMenuScrollToBottom={(e: any) => checkBottom(e)}
            onInputChange={(e: string) => {
              // setLoadCondition(false);
              setAssignGroup(e);
              setOffset(0);
            }}
            onMenuClose={() => {
              setAssignGroup("");
              setOffset(0);
            }}
            isLoading={fetchingUser}
            isDisabled={!!(isDisabledEditField && !addPresent)}
          />
          {/* </div> */}
        </div>

      </div>

      {!isNotShow ? (
        <div className="row mt-2">
          <div className="col-md-3">
            <label htmlFor="newPassword">
              New Password <span className="color-red">*</span>
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type={showNewPassword ? "text" : "password"}
                className={`form-control ${!!profileDetailsError?.newPasswordError
                  ? "error-border"
                  : null
                  }`}
                name="newPassword"
                disabled={!isEdit}
                value={newPassword}
                onChange={handlePassword}
                // onBlur={popOver}
                autoComplete="new-password"
              />
              <div
                className="icon-box"
                style={{ top: "7px" }}
                onClick={toggleShowNewPassword}
              >
                {showNewPassword ? (
                  <img src={viewEyeGray} alt="eye" />
                ) : (
                  <img src={hideEyeGray} alt="eye" />
                )}
              </div>
            </div>
            {newPassword &&
              newPassword.length &&
              passwordPopUpShow &&
              passwordResult &&
              Object.values(passwordResult).includes(false) ? (
              <PasswordValidationCard
                className={"tooltext-right"}
                triangleClassName={"triangle-right"}
                isLeast={passwordResult?.least}
                isUpperCase={passwordResult?.uppercase}
                isLowerCase={passwordResult?.lower}
                isSpecial={passwordResult?.special}
                isNumber={passwordResult?.number}
              />
            ) : (
              ""
            )}

            {!!profileDetailsError?.newPasswordError && (
              <small className="text-danger">
                {profileDetailsError?.newPasswordError}
              </small>
            )}
          </div>

          <div className="col-md-3">
            <label htmlFor="dateOfBirth">
              New Password Again <span className="color-red">*</span>{" "}
            </label>
            <div className="d-flex flex-row position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${!!profileDetailsError?.newPasswordAgainError
                  ? "error-border"
                  : null
                  }`}
                name="password"
                disabled={!isEdit}
                value={data?.access_details?.password || ""}
                autoComplete="off"
                onChange={handleAccessDeatilsForm}
              />
              <div
                className="icon-box"
                style={{ top: "7px" }}
                onClick={toggleShowPassword}
              >
                {showPassword ? (
                  <img src={viewEyeGray} alt="eye" />
                ) : (
                  <img src={hideEyeGray} alt="eye" />
                )}
              </div>
            </div>

            {!!profileDetailsError?.newPasswordAgainError && (
              <small className="text-danger">
                {profileDetailsError?.newPasswordAgainError}
              </small>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default AccessDetails;
